<template>
  <div class="leavesettings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col">
                <h3 class="page-title">Leave Settings</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Leave Settings</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="InitiateSettings"
                  ><i class="fa fa-plus"></i>
                  {{ newInit ? "Initiate Setting" : "Re-initiate Setting" }}</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <!-- Annual Leave -->
              <div
                class="card leave-box"
                :id="'leave_' + item.leaveType.name"
                v-for="item in LeaveSettings"
                :key="item.id"
              >
                <div class="card-body">
                  <div class="h3 card-title with-switch">
                    {{ item.leaveType.name }}
                    <div class="onoffswitch">
                      <input
                        type="checkbox"
                        name="onoffswitch"
                        class="onoffswitch-checkbox"
                        v-model="item.status"
                        :id="'switch_' + item.leaveType.name"
                      />
                      <label class="onoffswitch-label" for="switch_annual">
                        <span class="onoffswitch-inner"></span>
                        <span class="onoffswitch-switch"></span>
                      </label>
                    </div>
                  </div>
                  <div class="leave-item">
                    <!-- Annual Days Leave -->
                    <div class="leave-row">
                      <div class="leave-left">
                        <div class="input-box">
                          <div class="form-group">
                            <label>Days</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.days"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="leave-right">
                        <button
                          class="leave-edit-btn"
                          @click="selectSetting(item)"
                        >
                          Edit
                        </button>
                        <button
                          class="btn btn-primary leave-save-btn hide"
                          @click="UpdateSettings($event)"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                    <!-- /Annual Days Leave -->

                    <!-- Carry Forward -->
                    <!-- <div class="leave-row">
                                            <div class="leave-left">
                                                <div class="input-box">
                                                    <label class="d-block">Carry forward</label>
                                                    <div class="leave-inline-form">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio" v-model="item.carryOver"
                                                                name="inlineRadioOptions" id="carry_no" value="false"
                                                                disabled>
                                                            <label class="form-check-label" for="carry_no">No</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio" v-model="item.carryOver"
                                                                name="inlineRadioOptions" id="carry_yes" value="true"
                                                                disabled>
                                                            <label class="form-check-label" for="carry_yes">Yes</label>
                                                        </div>
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text">Max</span>
                                                            </div>
                                                            <input type="text" class="form-control" v-model="item.carryOverMax" disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="leave-right">
                                                <button class="leave-edit-btn" @click="selectSetting(item)">
                                                    Edit
                                                </button>
                                                <button class="btn btn-primary leave-save-btn hide"  @click="UpdateSettings($event)">Save</button>
                                            </div>
                                        </div> -->
                    <!-- /Carry Forward -->

                    <!-- Earned Leave -->
                    <!-- <div class="leave-row">
                                            <div class="leave-left">
                                                <div class="input-box">
                                                    <label class="d-block">Earned leave</label>
                                                    <div class="leave-inline-form">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio" v-model="item.earnedLeave"
                                                                name="inlineRadioOptions" id="earned_no" value="false"
                                                                disabled>
                                                            <label class="form-check-label" for="earned_no">No</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio" v-model="item.earnedLeave"
                                                                name="inlineRadioOptions" id="earned_yes"
                                                                value="true" disabled>
                                                            <label class="form-check-label" for="earned_yes">Yes</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="leave-right">
                                                <button class="leave-edit-btn" @click="selectSetting(item)">
                                                    Edit
                                                </button>
                                                <button class="btn btn-primary leave-save-btn hide"  @click="UpdateSettings($event)">Save</button>
                                            </div>
                                        </div> -->
                    <!-- /Earned Leave -->
                  </div>

                  <!-- Custom Policy -->
                  <div class="custom-policy">
                    <div class="leave-header">
                      <div class="title">Custom policy</div>
                      <div class="leave-action">
                        <button
                          class="btn btn-sm btn-primary"
                          type="button"
                          @click="openDialog(item.id)"
                        >
                          <i class="fa fa-plus"></i> Add custom policy
                        </button>
                      </div>
                    </div>
                    <div
                      class="table-responsive"
                      v-if="item.leavePolicies.length > 0"
                    >
                      <table
                        class="table table-hover table-nowrap leave-table mb-0"
                      >
                        <thead>
                          <tr>
                            <th class="l-name">Name</th>
                            <th class="l-days">Days</th>
                            <th class="l-assignee">Assignee</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="p in item.leavePolicies" :key="p.id">
                            <td>{{ p.policyName }}</td>
                            <td>{{ p.days }}</td>
                            <td>
                              <div
                                class="tt"
                                v-for="i in p.companyLeavePolicies"
                                :key="i.id"
                              >
                                <a href="#" class="avatar"
                                  ><img
                                    alt=""
                                    src="~@/assets/profiles/avatar-02.jpg"
                                    v-if="!i.employee.passportPhoto"/>
                                  <img
                                    alt=""
                                    :src="media + i.employee.passportPhoto"
                                    width="38"
                                    v-if="i.employee.passportPhoto"
                                /></a>

                                <span class="tttext">{{
                                  i.employee.firstName +
                                    " " +
                                    i.employee.lastName
                                }}</span>
                              </div>
                            </td>
                            <td class="text-right">
                              <div class="dropdown dropdown-action">
                                <a
                                  aria-expanded="false"
                                  data-toggle="dropdown"
                                  class="action-icon dropdown-toggle"
                                  href="#"
                                  ><i class="material-icons">more_vert</i></a
                                >
                                <div class="dropdown-menu dropdown-menu-right">
                                  <a
                                    class="dropdown-item"
                                    @click="setDeletePolicy(p)"
                                    ><i class="fa fa-trash-o m-r-5"></i>
                                    Delete</a
                                  >
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- /Custom Policy -->
                  <!-- Custom Policy -->
                  <div class="custom-policy">
                    <div class="leave-header">
                      <div class="title">Entitlement</div>
                      <div class="leave-action">
                        <button
                          class="btn btn-sm btn-primary"
                          type="button"
                          @click="openDialogImport(item.id)"
                        >
                          <i class="fa fa-plus"></i> Upload entitlement
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="leave-left">
                        {{ item.leaveEntitlements.length }} Entitlements
                      </div>
                      <div class="leave-right">
                        <a
                          class="btn"
                          @click="openDialogEnt(item.leaveEntitlements)"
                          >Open</a
                        >
                      </div>
                    </div>
                  </div>
                  <!-- /Custom Policy -->
                </div>
              </div>
              <!-- /Annual Leave -->
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- Add Custom Policy Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Custom Policy</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Policy Name <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="policy.policyName"
                />
              </div>
              <div class="form-group">
                <label>Days <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="policy.days" />
              </div>
              <div class="form-group leave-duallist">
                <label>Add employee</label>
                <div class="row">
                  <div class="col-lg-5 col-sm-5">
                    <select
                      id="customleave_select"
                      v-model="pickEmployees"
                      class="form-control"
                      size="8"
                      multiple="multiple"
                    >
                      <option
                        :value="item.id"
                        v-for="item in employees"
                        :key="item.id"
                        >{{ item.firstName + " " + item.lastName }}
                      </option>
                    </select>
                  </div>
                  <div class="multiselect-controls col-lg-2 col-sm-2">
                    <button
                      type="button"
                      id="customleave_select_rightAll"
                      @click="selectedAllFrom"
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-forward"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_rightSelected"
                      @click="selectedFrom"
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-chevron-right"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_leftSelected"
                      @click="selectedTo"
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_leftAll"
                      @click="selectedAllTo"
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-backward"></i>
                    </button>
                  </div>
                  <div class="col-lg-5 col-sm-5">
                    <select
                      id="customleave_select_to"
                      class="form-control"
                      size="8"
                      multiple="multiple"
                    ></select>
                  </div>
                </div>
              </div>

              <div class="submit-section">
                <button class="btn btn-primary submit-btn" @click="addPolicy">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Custom Policy Modal -->

        <!-- Edit Custom Policy Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Custom Policy</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Policy Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="policy.policyName"
                  />
                </div>
                <div class="form-group">
                  <label>Days <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="policy.days"
                  />
                </div>
                <div class="form-group leave-duallist">
                  <label>employee</label>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select"
                        v-model="selectedEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in employees"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="customleave_select_rightAll"
                        @click="selectedAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_rightSelected"
                        @click="selectedFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftSelected"
                        @click="selectedTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftAll"
                        @click="selectedAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Custom Policy Modal -->
        <!-- Edit Custom Policy Modal -->
        <v-dialog v-model="dialogEnt" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Leave Entitlement</h5>
              <button type="button" class="close" @click="closeEnt">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive" v-if="leaveEntitlements.length > 0">
                <div class="col-sm-6 col-md-12">
                  <div class="form-group form-focus">
                    <input
                      type="text"
                      class="form-control floating"
                      v-model="filterRankName"
                      style="height: 55px !important"
                    />
                    <label class="focus-label">Rank Name</label>
                  </div>
                </div>
                <table class="table table-hover table-nowrap leave-table mb-0">
                  <thead>
                    <tr>
                      <th class="l-name">Rank</th>
                      <th class="l-days">Min.Year</th>
                      <th class="l-days">Max.Year</th>
                      <th class="l-days">Days</th>
                      <th class="l-days">Add. Days</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in sortLeaveEntntitlementsList" :key="p.id">
                      <td>{{ p.rank.rankName }}</td>
                      <td>{{ p.minYear }}</td>
                      <td>{{ p.maxYear }}</td>
                      <td>{{ p.days }}</td>
                      <td>{{ p.additionalDay }}</td>
                      <td>
                        <a class="btn" @click="deleteLeaveEntitlement(p.id)"
                          >Delete</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Custom Policy Modal -->

        <!-- Delete Custom Policy Modal -->
        <v-dialog v-model="dialogDelete" max-width="425px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Custom Policy</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="deleteLeavePolicy"
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Custom Policy Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Entitlement</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <div class="col-md-12">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    v-if="message"
                  >
                    <strong>Success!</strong> {{ message }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <h3>Import Entitlement</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Level</strong> column you are expected to
                    get the value from their representing sheet. <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importEntitlement"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogEnt: false,
      dialogImport: false,
      message: null,
      dialogDelete: false,
      media: "data:image/jpeg;base64,",
      LeaveSettings: [],
      employees: [],
      EmployeePolicies: [],
      leaveEntitlements: [],
      policy: {
        id: 0,
        settingId: 0,
        policyName: "",
        days: 0
      },
      setting: {},
      error: null,
      selectedEmployees: [],
      pickEmployees: [],
      newInit: false,
      company: authenticationService.currentOfficeValue,
      file: null,
      fileName: null,
      filterRankName: ""
    };
  },

  computed: {
    sortLeaveEntntitlementsList: function() {
      return this.leaveEntitlements.filter(l =>
        l.rank.rankName
          .toLowerCase()
          .includes(this.filterRankName.toLowerCase())
      );
    }
  },
  methods: {
    close() {
      this.clearModel();
      this.dialog = false;
    },
    openDialog(settingId) {
      this.policy.settingId = settingId;
      this.dialog = true;
    },
    openDialogEnt(leaveEntitlements) {
      this.leaveEntitlements = leaveEntitlements;
      this.dialogEnt = true;
      this.sortLeaveEntntitlements();
      console.log(this.leaveEntitlements);
    },

    sortLeaveEntntitlements() {
      function compare(a, b) {
        if (a.rank.rankName.toLowerCase() < b.rank.rankName.toLowerCase()) {
          return -1;
        }
        if (a.rank.rankName.toLowerCase() > b.rank.rankName.toLowerCase()) {
          return 1;
        }
        return 0;
      }

      return this.leaveEntitlements.sort(compare);
    },
    openDialogImport(settingId) {
      this.setting.id = settingId;
      this.dialogImport = true;
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeEnt() {
      this.leaveEntitlements = [];
      this.dialogEnt = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearModel() {
      this.policy.policyName = "";
      this.policy.days = "";
      this.pickEmployees = [];
    },
    setEditPolicy(item) {
      this.selectPolicy(item);
      this.dialogEdit = true;
    },
    setDeletePolicy(item) {
      console.log(`item`, item);
      this.selectPolicy(item);
      this.dialogDelete = true;
    },
    selectPolicy(item) {
      this.policy = item;
      console.log(`item`, item);
      this.selectedEmployees = item.companyLeavePolicies.map(
        c => c.employee.id
      );
      setTimeout(() => this.selectedFrom(), 1000);
    },
    selectSetting(item) {
      this.setting = item;
    },
    selectedAllFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select_to")
        .append(selectOption);
      this.selectedEmployees.push(this.pickEmployees[0]);
      // console.log(this.selectedEmployees)
    },
    selectedAllTo() {
      var selectOption = [];
      $(document)
        .find("#customleave_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#customleave_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedEmployees));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    downloadTemplate() {
      employeeService
        .downloadEntitlementTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    InitiateSettings() {
      organizationService.initiateLeaveSettings(this.company.id).then(
        model => {
          this.LeaveSettings = model;
          this.newInit = false;
        },
        error => {
          error = error;
        }
      );
    },
    importEntitlement() {
      employeeService.importLeaveEntitlement(this.setting.id, this.file).then(
        response => {
          organizationService.getLeaveSettings(this.company.id).then(
            model => {
              this.LeaveSettings = model;
              if (model.length == 0) this.newInit = true;
              this.dialogEnt = false;
              this.message = " Leave Entitlement uploaded successfully";
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },
    async addPolicy() {
      this.policy.days = parseInt(this.policy.days);
      var id = await organizationService.addPolicy(this.policy);
      if (id) {
        await employeeService.addEmployeeLeavePolicy(
          id,
          this.selectedEmployees
        );
        var policies = await employeeService.getEmployeePolicies(
          this.company.id
        );
        this.EmployeePolicies = policies;
        organizationService.getLeaveSettings(this.company.id).then(
          model => {
            this.LeaveSettings = model;
            this.LeaveSettings.forEach(l => {
              l.leavePolicies.forEach(p => {
                p.companyLeavePolicies = policies.filter(
                  c => c.policyId == p.id
                );
              });
            });
            // console.log(this.LeaveSettings)
            if (model.length == 0) this.newInit = true;
          },
          error => {
            error = error;
          }
        );
        this.close();
        this.clearModel();
      }
    },
    getEmployees() {
      employeeService.getEmployees(this.company.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    GetSettings() {
      organizationService.getLeaveSettings(this.company.id).then(
        model => {
          this.LeaveSettings = model;
          if (model.length == 0) this.newInit = true;
        },
        error => {
          error = error;
        }
      );
    },
    GetEmployeePolicies() {
      employeeService.getEmployeePolicies(this.company.id).then(
        policies => {
          this.EmployeePolicies = policies;
          organizationService.getLeaveSettings(this.company.id).then(
            model => {
              this.LeaveSettings = model;
              // console.log(`model settngs`, model)
              this.LeaveSettings.forEach(l => {
                l.leavePolicies.forEach(p => {
                  console.log(`p`, p);
                  p.companyLeavePolicies = policies.filter(
                    c => c.policyId == p.id
                  );
                });
              });
              // console.log(this.LeaveSettings)
              if (model.length == 0) this.newInit = true;
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          error = error;
        }
      );
    },
    GetLeaveEntitlements() {
      employeeService.getEmployeePolicies(this.company.id).then(
        policies => {
          this.EmployeePolicies = policies;
          organizationService.getLeaveSettings(this.company.id).then(
            model => {
              this.LeaveSettings = model;
              // console.log(`model settngs`, model)
              this.LeaveSettings.forEach(l => {
                l.leavePolicies.forEach(p => {
                  console.log(`p`, p);
                  p.companyLeavePolicies = policies.filter(
                    c => c.policyId == p.id
                  );
                });
              });
              // console.log(this.LeaveSettings)
              if (model.length == 0) this.newInit = true;
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          error = error;
        }
      );
    },
    async UpdateSettings(event) {
      this.setting.days = parseInt(this.setting.days);
      this.setting.carryOverMax = parseInt(this.setting.carryOverMax);
      this.setting.carryOver = this.setting.carryOver == "true";
      this.setting.earnedLeave = this.setting.earnedLeave == "true";
      this.setting.status = this.setting.status ? 1 : 0;
      await organizationService.updateLeaveSettings(this.setting);
      var policies = await employeeService.getEmployeePolicies(this.company.id);

      this.EmployeePolicies = policies;
      organizationService.getLeaveSettings(this.company.id).then(
        model => {
          this.LeaveSettings = model;
          this.LeaveSettings.forEach(l => {
            l.leavePolicies.forEach(p => {
              p.companyLeavePolicies = policies.filter(c => c.policyId == p.id);
            });
          });
          // console.log(this.LeaveSettings)
          if (model.length == 0) this.newInit = true;
        },
        error => {
          error = error;
        }
      );

      $(event.target)
        .parent()
        .find(".leave-cancel-btn")
        .removeClass("btn btn-white leave-cancel-btn")
        .addClass("leave-edit-btn")
        .text("Edit");
      $(event.target)
        .parent()
        .find(".leave-save-btn")
        .addClass("hide");
      $(event.target)
        .parent()
        .parent()
        .find("input")
        .prop("disabled", true);
    },

    deleteLeavePolicy() {
      // console.log(`this.policy`, this.policy)
      let employeeId = [];
      this.policy.companyLeavePolicies.forEach(id => {
        employeeId.push(id.employeeId);
      });
      // employeeId.push(this.policy.companyLeavePolicies[0].employeeId);
      let id = this.policy.id;
      // console.log(
      //   this.policy.companyLeavePolicies[0].employeeId,
      //   this.policy.id,
      //   employeeId
      // );
      employeeService.deleteEmployeeLeavePolicy(id, employeeId).then(id => {
        this.closeDelete();
        employeeService.getEmployeePolicies(this.company.id).then(
          policies => {
            this.EmployeePolicies = policies;
            organizationService.getLeaveSettings(this.company.id).then(
              model => {
                this.LeaveSettings = model;
                // console.log(`model settngs`, model)
                this.LeaveSettings.forEach(l => {
                  l.leavePolicies.forEach(p => {
                    console.log(`p`, p);
                    p.companyLeavePolicies = policies.filter(
                      c => c.policyId == p.id
                    );
                  });
                });
                // console.log(this.LeaveSettings)
                if (model.length == 0) this.newInit = true;
              },
              error => {
                error = error;
              }
            );
          },
          error => {
            error = error;
          }
        );
      });
    },
    deleteLeaveEntitlement(id) {
      // console.log(`this.policy`, this.policy)
      employeeService.removeLeaveEntitlement(id).then(
        id => {
          organizationService.getLeaveSettings(this.company.id).then(
            model => {
              this.LeaveSettings = model;
              // console.log(`model settngs`, model)
              this.LeaveSettings.forEach(l => {
                l.leavePolicies.forEach(p => {
                  console.log(`p`, p);
                  p.companyLeavePolicies = policies.filter(
                    c => c.policyId == p.id
                  );
                });
              });
              // console.log(this.LeaveSettings)
              if (model.length == 0) this.newInit = true;
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          error = error;
        }
      );
    }
  },
  mounted() {
    this.getEmployees();
    //this.GetSettings()
    this.GetEmployeePolicies();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    var getSelect = function(ele) {
      var selected = [];
      ele.find("option:selected").each(function() {
        // console.log(this)
        selected.push($(this));
      });
      return selected;
    };
    // Leave Settings button show
    $(document).on("click", ".leave-edit-btn", function() {
      $(this)
        .removeClass("leave-edit-btn")
        .addClass("btn btn-white leave-cancel-btn")
        .text("Cancel");
      if (
        $(this)
          .closest("div.leave-right")
          .has("leave-save-btn")
      ) {
        $(this)
          .closest("div.leave-right")
          .find(".leave-save-btn")
          .removeClass("hide");
      }
      $(this)
        .parent()
        .parent()
        .find("input")
        .prop("disabled", false);
      return false;
    });
    $(document).on("click", ".leave-cancel-btn", function() {
      $(this)
        .removeClass("btn btn-white leave-cancel-btn")
        .addClass("leave-edit-btn")
        .text("Edit");
      $(this)
        .closest("div.leave-right")
        .find(".leave-save-btn")
        .addClass("hide");
      $(this)
        .parent()
        .parent()
        .find("input")
        .prop("disabled", true);
      return false;
    });
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });

    $(document).on("change", ".leave-box .onoffswitch-checkbox", function() {
      var id = $(this)
        .attr("id")
        .split("_")[1];
      if ($(this).prop("checked") == true) {
        $("#leave_" + id + " .leave-edit-btn").prop("disabled", false);
        $("#leave_" + id + " .leave-action .btn").prop("disabled", false);
      } else {
        $("#leave_" + id + " .leave-action .btn").prop("disabled", true);
        $("#leave_" + id + " .leave-cancel-btn")
          .parent()
          .parent()
          .find("input")
          .prop("disabled", true);
        $("#leave_" + id + " .leave-cancel-btn")
          .closest("div.leave-right")
          .find(".leave-save-btn")
          .remove();
        $("#leave_" + id + " .leave-cancel-btn")
          .removeClass("btn btn-white leave-cancel-btn")
          .addClass("leave-edit-btn")
          .text("Edit");
        $("#leave_" + id + " .leave-edit-btn").prop("disabled", true);
      }
    });
    $(".leave-box .onoffswitch-checkbox").each(function() {
      var id = $(this)
        .attr("id")
        .split("_")[1];
      if ($(this).prop("checked") == true) {
        $("#leave_" + id + " .leave-edit-btn").prop("disabled", false);
        $("#leave_" + id + " .leave-action .btn").prop("disabled", false);
      } else {
        $("#leave_" + id + " .leave-action .btn").prop("disabled", true);
        $("#leave_" + id + " .leave-cancel-btn")
          .parent()
          .parent()
          .find("input")
          .prop("disabled", true);
        $("#leave_" + id + " .leave-cancel-btn")
          .closest("div.leave-right")
          .find(".leave-save-btn")
          .remove();
        $("#leave_" + id + " .leave-cancel-btn")
          .removeClass("btn btn-white leave-cancel-btn")
          .addClass("leave-edit-btn")
          .text("Edit");
        $("#leave_" + id + " .leave-edit-btn").prop("disabled", true);
      }
    });
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "leavesettings"
};
</script>



// WEBPACK FOOTER //
// src/components/leaves/leavesettings.vue